import { render } from "./BrandModels.vue?vue&type=template&id=32774f8c"
import script from "./BrandModels.vue?vue&type=script&lang=js"
export * from "./BrandModels.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./BrandModels.vue?vue&type=style&index=0&id=32774f8c&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script